const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMWM2LjA3NSAwIDExIDQuOTI1IDExIDExcy00LjkyNSAxMS0xMSAxMVMxIDE4LjA3NSAxIDEyIDUuOTI1IDEgMTIgMXpNMyAxMmE5IDkgMCAwIDAgMTQuNjE3IDcuMDMyTDQuOTY3IDYuMzgyQTguOTYyIDguOTYyIDAgMCAwIDMgMTJ6bTktOWE4Ljk2MiA4Ljk2MiAwIDAgMC01LjYxNyAxLjk2OGwxMi42NSAxMi42NUE5IDkgMCAwIDAgMTIgM3oiICBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export {
  M as default
};
//# sourceMappingURL=disabled-d1aa3778.mjs.map
